var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle__container"},[_c('button',{staticClass:"unbutton toggle"},[_c('div',{staticClass:"circle",class:_vm.Switch && 'active'}),_vm._v(_vm._s(_vm.Label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }